<template>
  <div class="helpDetail">
    <div class="helpDetailBox">
      <!-- 左边 -->
      <div class="helpDetail_left">
        <div class="soluBottomL">
          <div class="soluBottomL_title">全部文档</div>
          <el-menu :default-active="$route.query.wordNo" @open="handleOpen" @close="handleClose" :unique-opened="true"  
			><div
              v-for="(newitems, indexs) in newList"
              :key="indexs"
              @click="fn(indexs)"
              :class="clickNum === indexs ? 'active' : ''"
            >
			
              <el-submenu :index="indexs + ''"  >
                <template slot="title" v-if="newitems.title != null">
                  <span>{{ newitems.title }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
				  v-for="(items, index) in newitems.listMess"
				  :key="index"
				   :index="items.wordNo"
                    @click="getSoluTbas(indexs, index,items.wordNo)"
                    >{{ items.title }}</el-menu-item
                  >
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-menu>
        </div>
      </div>
      <!-- 右边 -->
      <div class="helpDetail_right">
        <div class="flex helpDetail_rightBox">
          <div class="flex helpDetail_right_position">
              <p>当前位置：</p>
			  <el-breadcrumb separator=">">
			    <el-breadcrumb-item>文档</el-breadcrumb-item>
			    <el-breadcrumb-item v-if="this.formVal.itemName != null">{{this.formVal.itemName}}</el-breadcrumb-item>
			    <el-breadcrumb-item>{{this.formVal.title}}</el-breadcrumb-item>
			  </el-breadcrumb>
            <!-- <p>文档 ></p>
              <p class="positon_cu">{{this.formVal.itemName}}></p>
              <p class="positon_cu">{{this.formVal.title}}</p> -->
          </div>
          <div class="soluBottomInput">
            <input type="text" placeholder="输入文档名" v-model="helpCenterInput"/>
            <i class="el-icon-search"  @click="searchInput()"></i>
          </div>
        </div>
          <div class="helpDetail_right_mess">
            <div class="helpDetail_right_title">
              <h3>{{this.formVal.title}}</h3>
              <p>发布时间：{{this.formVal.createDate}}</p>
            </div>
            <div v-html="this.formVal.content" class="helpDetail_right_html vHtmlMess"></div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {findWordInfoList,getInfoByWordNo} from "../../utils/wordInfo";

export default {
  name: "helpDetail",
  data() {
    return {
      helpCenterInput: '',
      newList: [],
      soluTabsIndex: null,
      newListIndex: null,
      clickNum: 0,
        formVal:{},
    };
  },
  created() {
      let wordNo = this.$route.query.wordNo;
      this.getInfoByWordNo(wordNo);
      this.getWordInfoList();
  },
  methods: {
    handleOpen(key, keyPath) {
      this.newListIndex = key;
      // this.programUuid = this.newList[key].uuid;
      this.soluTabsIndex = undefined;
    },
    handleClose(key, keyPath) {
      this.newListIndex = undefined;
      this.soluTabsIndex = undefined;
    },
    fn(index) {
      this.clickNum = index;
    },
    getSoluTbas(i, index,wordNo) {
      //   this.programUuid =
      //     this.newList[i].children == null
      //       ? this.newList[i].uuid
      //       : this.newList[i].children[index].uuid;
      var test=window.location.href
      console.log(test)
      if(test.indexOf("source")<=0){
        let url = test.substring(0,test.indexOf("?"))
        history.pushState("", "增财运-帮助中心详情", url+"?wordNo="+wordNo);
      }
      this.getInfoByWordNo(wordNo);
      this.newList.forEach((news, t) => {
		  console.log(news)
        if (news.children != null) {
          news.children.forEach((item, tIndex) => {
            if (i != t || tIndex !== index) {
              item.active = false;
            } else {
              item.active = true;
            }
          });
        }
      });
      this.soluTabsIndex = index;
      this.newListIndex = i;
    },
      getWordInfoList(){
          let params = {
              title: this.helpCenterInput,
          };
          findWordInfoList(params).then((res)=>{
              this.newList = res;
			  res.forEach((req,reqIndex)=>{
				  req.listMess.forEach((i,Iindex)=>{
					  // console.log(reqIndex)
					  if(i.wordNo === this.$route.query.wordNo){
						  console.log(reqIndex,222)
						  this.clickNum = reqIndex;
					  }
					  console.log(this.clickNum)
				  })
			  })
			  // console.log(res,11111)
          })

      },
    searchInput(){
      this.formVal ={};
      let params = {
        title: this.helpCenterInput,
      };
      findWordInfoList(params).then((res)=>{
        this.newList = res
        if(res.length>0){
          this.formVal = res[0].listMess[0];
        }
      })
    },
    getInfoByWordNo(wordNo){
      let param={wordNo:wordNo}
      getInfoByWordNo(param).then((res)=>{
        if(res.success)
          this.formVal = res.data;
		  // console.log(this.formVal,11111)
      });

    },
  },
};
</script>

<style scoped lang="less">
.helpDetail {
  background: rgb(251, 251, 251);
  .helpDetailBox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding-top: 20px;

  }
  .helpDetail_left {
    padding-bottom: 40px;
    .soluBottomL {
      // margin-bottom: 34px;
      text-align: center;
      width: 255px;
      flex-shrink: 0;
      background-color: #fff;
      .soluBottomLTit {
        font-size: 18px;
        color: #fff;
        background: #1181ff;

        text-align: center;
        height: 80px;
        line-height: 80px;
      }
      .soluBottomLtab {
        font-size: 14px;
        text-align: center;
        border: 1px solid #efefef;
        box-shadow: 0px 1px 7px 0px #dadada;

        p {
          height: 58px;
          line-height: 58px;
          border-bottom: 1px solid #efefef;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;

          // span {
          //   margin-left: 10px;
          // }
        }
        p:nth-last-child(1) {
          border-bottom: none;
        }
        .p_active {
          width: 100%;
          background: #e7f2ff;
        }
      }
      .soluBottomLtab_active {
        background: #1181ff;
        height: 15px;
        width: 3px;
        display: inline-block;
      }
      .soluBottomL_title {
        height: 56px;
        line-height: 56px;
        background: #1181ff;
        color: #fff;

      }
    }
    .soluBottomR {
      margin-left: 28px;

      width: 100%;
      .suluBottomBig2 {
        margin-left: 28px;
        width: 100%;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #d4d4d4;
        line-height: 650%;
      }
      .suluBottomBig {
        flex-wrap: wrap;
        justify-content: space-between;

        .soluBottomRList {
          cursor: pointer;
          background: #fff;
          margin-bottom: 18px;
          // width: 45%;
          // height: 120px;
          padding: 15px;
          border-radius: 10px;
          .soluBottomRImg {
            width: 260px;
            height: 132px;
            margin-right: 18px;
            flex-shrink: 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .soluBottomRMess {
            position: relative;
            h4 {
              font-weight: 400;
              font-size: 15px;
              display: -webkit-box;
              overflow: hidden;
              white-space: normal !important;
              text-overflow: ellipsis;
              word-wrap: break-word;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
                "Droid Sans", "Helvetica Neue";
            }
            .soluBottomRMessP {
              color: #777;
              font-size: 12px;
              margin-top: 14px;
              line-height: 22px;
              display: -webkit-box;
              overflow: hidden;
              white-space: normal !important;
              text-overflow: ellipsis;
              word-wrap: break-word;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
            .new_times {
              position: absolute;
              font-size: 12px;
              color: #b1b1b1;
              bottom: 0;
              p:nth-child(2) {
                margin: 0 22px;
              }
            }
          }
        }
        .soluBottomRList:hover {
          box-shadow: 0px 1px 7px 0px #dadada;
        }
      }
      .pageina {
        margin-top: 74px;
        text-align: right;
      }
    }
    /deep/.el-submenu__title {
      font-size: 16px;
      border-bottom: 1px solid #efefef;
    }
    .active {
      background: #409eff;
      span {
        color: #fff !important;
      }
    }
    /deep/.el-submenu.is-active .el-submenu__title {
      border-bottom: 1px solid #efefef;
    }
    /deep/.el-submenu .el-menu-item {
      border-bottom: 1px solid #efefef;
    }
    /deep/.el-menu-item-group__title {
      padding: 0;
    }

    /deep/.el-submenu__title:hover {
      background: #60a5f4;
      color: #fff;
    }
    /deep/.el-menu {
      background-color: none;
    }
  }
  .helpDetail_right {
      margin-left: 28px;
      width: 100%;
      .helpDetail_rightBox {
        align-items: center;
        justify-content: space-between;
        .soluBottomInput {
          position: relative;
          margin-bottom: 10px;
          input {
            border: none;
            background: #efefef;
            padding: 5px 13px;
            border-radius: 30px;
            height: 20px;
            width: 158px;
            font-size: 12px;
            color: #969696;
          }
          i {
            position: absolute;
            right: 5%;
            top: 50%;
            color: #969696;
            transform: translate(0, -50%);
          }
        }
      }
      .helpDetail_right_position {
        font-size: 14px;
        color: #808080;
        padding-bottom: 20px;
		align-items: center;
        .positon_cu{
            cursor: pointer;
        }
      }
      .helpDetail_right_mess {
          background: #fff;
          // width: 100%;
          padding: 20px;
          .helpDetail_right_title {
            border-bottom: 1px solid #efefef;
            padding-bottom: 6px;
            h3 {
              text-align: center;
              margin-bottom: 6px;
              color: #082a48;
            }
            p {
              font-size: 14px;
              color: #bbb;
            }
          }
          .helpDetail_right_html {
            white-space: pre-wrap;
            /deep/p {
              min-height: 22px;
            }
            /deep/img {
              max-width: 100% !important;
            }
            /deep/table {
              border: none;
              border-collapse: collapse;
            }
            /deep/table td,
            /deep/table th{
              border: 1px solid #ccc;
              padding: 3px 5px;
              min-width: 50px;
              height: 20px;
            }
            /deep/table th {
              border-right: 1px solid #ccc;
              border-bottom: 2px solid #ccc;
              text-align: center;
              background-color: #f1f1f1;
            }
          }

      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/helpCenter/helpCenterDetail.vue